import { Button, FormControl, IconButton, Input, InputAdornment, InputLabel, Paper, TextField, Typography } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import React, { Component } from 'react';
import LockedDialog from '../Components/LockedDialog';
import { replaceGateway } from '../Networking/APIClient';

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginLeft: 20,
};

const passwordStyle = {
    width: '100%',
    marginTop: 16,
    marginBottom: 8,
}

const importantInfoStyle = {
    color: 'red',
    fontWeight: 'bold',
}

let self;
let t;

class ReplaceGateway extends Component {
    constructor(props) {
        super(props);

        self = this;
        t = props.t;

        this.state = {
            currentPageState: 'before',
            success: null,
            old_value_code: {
                value: self.props.gatewayToBeReplaced !== null ? self.props.gatewayToBeReplaced : '',
                error: false,
                helperText: '',
            },
            new_value_code: {
                value: '',
                error: false,
                helperText: '',
            },
            email: {
                value: self.props.data.customer.email !== null ? self.props.data.customer.email : '',
                error: false,
                helperText: '',
            },
            password: {
                value: props.credentials.password !== 'NotASecret' ? props.credentials.password : '',
                error: false,
                helperText: '',
                showPassword: false
            },
            lockedDialogOpen: false,
        }
    }

    onReplaceClicked = e => {
        e.preventDefault();
        self.props.setLoading(true);
        const bothValueCodesAreTheSame = self.state.old_value_code.value == self.state.new_value_code.value;
        // Clear any errors between attempts.
        self.setState({
            old_value_code: {
                value: self.state.old_value_code !== null ? self.state.old_value_code.value : '',
                error: false,
                helperText: '',
            },
            new_value_code: {
                value: self.state.new_value_code !== null ? self.state.new_value_code.value : '',
                error: false,
                helperText: '',
            },
            email: {
                value: self.props.data.customer.email !== null ? self.props.data.customer.email : '',
                error: false,
                helperText: '',
            },
            password: {
                value: self.props.credentials.password !== 'NotASecret' ? self.props.credentials.password : '',
                error: false,
                helperText: '',
                showPassword: false
            },
        });

        // Check if both provided value codes are the same. If they are, show error in input field.
        if (bothValueCodesAreTheSame) {
            self.setState({
                new_value_code: {
                    value: self.state.new_value_code.value,
                    error: true,
                    helperText: t('new_value_code_cant_be_the_old_value_code'),
                }
            });
            self.props.setLoading(false);
            return;
        }
        // Value codes are valid so far, hide any error text in input field
        else {
            self.setState({
                old_value_code: {
                    value: self.state.old_value_code.value,
                    error: false,
                    helperText: '',
                },
                new_value_code: {
                    value: self.state.new_value_code.value,
                    error: false,
                    helperText: '',
                }
            });
        }

        const onOk = function onOk() {
            self.props.setLoading(false);
            // Gateway Replacement successful. Tell customer.
            self.setState({
                currentPageState: 'after',
                success: true
            });
        };

        const onError = function onError(replaceGateWayError) {
            self.props.setLoading(false);
            // Handle different errors
            switch (replaceGateWayError) {
                // Authentication issue, user has provided invalid credentials
                case null: {
                    self.setState({
                        email: {
                            value: self.state.email.value,
                            error: true,
                            helperText: t('user_email_or_password_wrong'),
                        },
                        password: {
                            value: self.state.password.value,
                            error: true,
                            helperText: t('user_email_or_password_wrong'),
                        }
                    });
                    return;
                }
                // Customer has provided valid credentials, but backend reports the two value codes being the same.
                // Should not happen (we check for that above), but this isn't a critical error.
                case 'ValueCodesIdenticalOrNull':
                    self.setState({
                        new_value_code: {
                            value: self.state.new_value_code.value,
                            error: true,
                            helperText: t('new_value_code_cant_be_the_old_value_code'),
                        }
                    });
                    return;
                // The customer has provided valid credentials, but doesn't seem to have a Customer Relation to the old gateway.
                // Presumably the customer entered the incorrect old value code.
                case 'RelationNotFound':
                    self.setState({
                        old_value_code: {
                            value: self.state.old_value_code.value,
                            error: true,
                            helperText: t('invalid_value_code'),
                        },
                    });
                    return;
                    // The customer has entered a value code that BPAPI can't find in the system.
                case 'GatewayAlreadyOwnedByCustomer':
                case 'GatewayWithValueCodeNotFound': {
                    self.setState({
                        new_value_code: {
                            value: self.state.new_value_code.value,
                            error: true,
                            helperText: t('invalid_value_code'),
                        },
                    });
                    return;
                }
                case 'NotFreeGateway': {
                    self.setState({
                        currentPageState: 'after',
                        success: false,
                        failureReason: 'NotFreeGateway',
                        replaceGatewayCriticalError: false,
                    });
                    break;
                }
                // We assume that we managed to delete the Customer Relation, and therefore have a critical error.
                // No point in asking customer to retry at this point.
                default: {
                    self.setState({
                        currentPageState: 'after',
                        success: false,
                        replaceGatewayCriticalError: true,
                    });
                    break;
                }
            }
        };

        replaceGateway(self.props.credentials, this.state.old_value_code.value, this.state.new_value_code.value, this.state.email.value, this.state.password.value, onOk, onError)
    }

    onCancelClicked = e => {
        e.preventDefault();

        self.props.updateAppData();

        // We can assume we've gone through with parts of the replacement
        // If we've had a critical error occur, we're highly likely to already have removed the customer relation,
        // therefore we don't know if we can advise the customer to do anything but close SAM
        if (self.state.replaceGatewayCriticalError) {
            // If we were sent to SAM with value code parameter (presumably from App) and we've replaced that value code
            // Show unescapable dialog with no other option but to leave
            if (self.props.initialValueCode != null && self.state.old_value_code !== null && self.state.old_value_code.value === self.props.initialValueCode) {
                self.setState({
                    lockedDialogOpen: true,
                });
                return;
            }
            // If a customer has multiple gateways and wasn't sent to SAM with initial value code,
            // Send them to AccountOverview.
            if (self.props.hasMultipleGateways && self.state.old_value_code !== null  || self.state.old_value_code.value !== self.props.initialValueCode) {
                self.props.updatePage('account_overview');
                return;
            }
            // If we used a web browser to login to SAM, it makes more sense to log them out at this point.
            self.props.logout();
            return;
        }
        // If we haven't experienced a critical error, we can ask the customer to try again.
        // Send them back to the form.
        self.setState({
            currentPageState: 'before',
            success: null,
            failureReason: null,
            old_value_code: {
                value: self.state.old_value_code !== null ? self.state.old_value_code.value : '',
                error: false,
                helperText: '',
            },
            new_value_code: {
                value: self.state.new_value_code !== null ? self.state.new_value_code.value : '',
                error: false,
                helperText: '',
            },
            email: {
                value: self.props.data.customer.email !== null ? self.props.data.customer.email : '',
                error: false,
                helperText: '',
            },
            password: {
                value: self.props.credentials.password !== 'NotASecret' ? self.props.credentials.password : '',
                error: false,
                helperText: '',
                showPassword: false
            },
        });
    }

    onFinishClicked = e => {
        e.preventDefault();

        self.props.updateAppData();

        // If we were sent to SAM with value code parameter (presumably from App) and we've replaced that value code
        // Show unescapable dialog with no other option but to leave
        if (self.props.initialValueCode != null && self.state.old_value_code !== null && self.state.old_value_code.value === self.props.initialValueCode) {
            self.setState({
                lockedDialogOpen: true,
            });
            return;
        }
        // If a customer has multiple gateways and wasn't sent to SAM with initial value code,
        // Send them to AccountOverview.
        if (self.props.hasMultipleGateways && self.state.old_value_code !== null  || self.state.old_value_code.value !== self.props.initialValueCode) {
            self.props.updatePage('account_overview');
            return;
        }
        // If we used a web browser to login to SAM, it makes more sense to log them out at this point.
        self.props.logout();
        return;
    }

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPassword = () => {
        this.setState((prevState) => {
            return {
                password: {
                    value: prevState.password.value,
                    error: prevState.password.error,
                    helperText: prevState.password.helperText,
                    showPassword: !prevState.password.showPassword
                }
            }
        });
    };

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    // Dialog which has the function of locking the customer out of the rest of SAM.
    // Only option is to close SAM/reload SAM.
    generateLockedDialog() {
        const lockedDialog =
        <LockedDialog
            t={t}
            open={this.state.lockedDialogOpen}
        />
        return lockedDialog;
    }

    render() {
        let content;
        switch (this.state.currentPageState) {
            case 'before':
                content =
                    <div className="content-container">
                        <div className="typography-title-container">
                            <Typography variant="title">
                                {t('gateway_replacement_title')}
                            </Typography>
                        </div>
                        <div className="typography-title-container">
                            <Typography variant="subheading">
                                {t('gateway_replacement_information')}
                            </Typography>
                            <p style={importantInfoStyle}>{t('gateway_replacement_important_notice')}</p>
                            <br/>
                        </div>
                        <form>
                            {/* Input field old gateway value code */}
                            <TextField style={editTextStyle}
                                error={this.state.old_value_code.error}
                                helperText={this.state.old_value_code.helperText}
                                id="old_value_code"
                                value={this.state.old_value_code.value}
                                label={t('gateway_replacement_old_value_code')}
                                onChange={this.handleChange('old_value_code')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                margin="normal" />
                            {/* Input field new gateway value code */}
                            <TextField style={editTextStyle}
                                error={this.state.new_value_code.error}
                                helperText={this.state.new_value_code.helperText}
                                id="new_value_code"
                                value={this.state.new_value_code.value}
                                label={t('gateway_replacement_new_value_code')}
                                onChange={this.handleChange('new_value_code')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                margin="normal" />
                            <br/>
                            <br/>
                            <br/>
                            {/* Input customer email, for authentication purposes */}
                            <TextField style={editTextStyle}
                                error={this.state.email.error}
                                helperText={this.state.email.helperText}
                                id="email"
                                value={this.state.email.value}
                                label={t('my_email')}
                                onChange={this.handleChange('email')}
                                onKeyPress={e => this.onKeyPressed(e)}
                                margin="normal" />
                                {/* Input customer password, for authentication purposes */}
                            <FormControl style={passwordStyle}>
                                <InputLabel htmlFor="password">{t('password')}</InputLabel>
                                <Input
                                    id="password"
                                    type={this.state.password.showPassword ? 'text' : 'password'}
                                    value={this.state.password.value}
                                    error={this.state.password.error}
                                    /* This is a hint, which browsers are not required to comply with.
                                    However modern browsers have stopped autofilling <input> elements with autocomplete="new-password" for this very reason. */
                                    autoComplete="new-password"
                                    onChange={this.handleChange('password')}
                                    onKeyPress={e => this.onKeyPressed(e)}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="Toggle password visibility"
                                                onClick={this.handleClickShowPassword}
                                                onMouseDown={this.handleMouseDownPassword}>
                                                {this.state.password.showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </form>
                        <div style={buttonContainerStyle}>
                            {/* Submit form and initiate attempt to send API call to BPAPI/ChangeGatewayOwnership */}
                            <Button
                                style={buttonStyle}
                                variant="contained"
                                color="primary"
                                /* Don't allow the customer to click 'Replace' until every input has something in it */
                                disabled={this.state.password.value == '' || this.state.old_value_code.value == '' || this.state.new_value_code.value == '' || this.state.email.value == ''}
                                onClick={e => this.onReplaceClicked(e)}>
                                {t('replace')}
                            </Button >
                        </div>
                    </div>
                break;
            case 'after':
                content =
                    <div className="content-container">
                        <div>
                            <div className="typography-title-container">
                                <Typography variant="title" color={this.state.success ? "default" : "error"}>
                                    {this.state.success ? t('gateway_replacement_success_title') : t('gateway_replacement_failure_title')}
                                </Typography>
                            </div>
                            <div>
                                {this.state.failureReason == 'NotFreeGateway' ? <Typography variant="subheading">
                                    {t('gateway_replacement_failure_reason_not_free_gateway') + self.state.new_value_code.value}
                                </Typography> : null}
                                <Typography variant="subheading">
                                    {/* If ReplaceGateway fails, but the error isn't critical (we haven't removed the Customer Relation), we can tell the customer to try again.
                                    If error is critical, tell them we're on the case and will contact them. */}
                                    {this.state.success ? t('gateway_replacement_success_message') : self.state.changeGatewayCriticalError ? t('gateway_replacement_failure_message_1') : t('gateway_replacement_failure_message_2')}
                                </Typography>
                                {/* If ReplaceGateway fails after Customer Relation is deleted, tell the customer they'll hear from us within a few days.
                                Uses the same translation key as Gateway Ownership Change */}
                                {!this.state.success ? <Typography variant="subheading">{self.state.changeGatewayCriticalError ? t('ownership_change_failure_message_2') : null}</Typography> : null}
                            </div>
                            <div style={buttonContainerStyle}>
                                <Button
                                    style={buttonStyle}
                                    variant="contained"
                                    color="primary"
                                    onClick={e => this.state.success ? this.onFinishClicked(e) : this.onCancelClicked(e)}>
                                    {this.state.success ? t('finished') : t('ok')}
                                </Button >
                            </div>
                        </div>
                    </div>;
                break;
            default:
                break;
        }

        return (
            <div className="content-frame">
                {this.state.lockedDialogOpen ? this.generateLockedDialog() : null}
                <Paper className="content">
                    {!self.props.isLoading ? content : null}
                </Paper>
            </div>);
    }
}

const editTextStyle = {
    width: '100%',
}

export default ReplaceGateway;


// WEBPACK FOOTER //
// ./src/Pages/ReplaceGateway.js